// src/subscreens/customer/home/FAQ/FAQ.jsx
import React, { useState, useEffect, useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaLeaf, FaPlus, FaMinus } from "react-icons/fa";
import axios from "axios";
import MyContext from "../../../context/MyContext";
import { SkeletonBlock } from "../../../components/general/skeleton/SkeletonBlock";
import "../../../assets/css/customer/contact/contactInfo/Contactinfo.css";

import seeds from "../../../assets/images/home/subcategories/crops/seeds.jpg";
import fruits from "../../../assets/images/home/subcategories/crops/fruits.jpg";
import fertilizer from "../../../assets/images/home/subcategories/shop products/fertilizer.jpg";

const FAQ = () => {
  const { baseUrl } = useContext(MyContext);

  const [activeTab, setActiveTab] = useState("customer");
  const [faqData, setFaqData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openId, setOpenId] = useState(null);

  // ── ek function per role, endpoint match karte hue ──
  const viewAllCustomerFaqs = () => {
    return axios.get(`${baseUrl}/customer/faq/viewAllFaqs`, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  };

  const viewAllSellerFaqs = () => {
    return axios.get(`${baseUrl}/seller/faq/viewAllFaqs`, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  };

  const viewAllDeliveryFaqs = () => {
    return axios.get(`${baseUrl}/delivery/faq/viewAllFaqs`, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  };

  const fetchFaqsForTab = (tab) => {
    setLoading(true);
    setOpenId(null);

    let request;
    if (tab === "seller") {
      request = viewAllSellerFaqs();
    } else if (tab === "delivery") {
      request = viewAllDeliveryFaqs();
    } else {
      request = viewAllCustomerFaqs();
    }

    request
      .then((response) => {
        if (response.data.hasOwnProperty("error")) {
          setFaqData([]);
        } else {
          setFaqData(response.data.faqs || []);
        }
        setLoading(false);
      })
      .catch(() => {
        setFaqData([]);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (!baseUrl) return;
    fetchFaqsForTab(activeTab);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [baseUrl, activeTab]);

  const toggle = (id) => setOpenId((prev) => (prev === id ? null : id));

  return (
    <section className="faq-section">
      <Container>
        <div className="faq-header">
          <div className="faq-header-badge">
            <FaLeaf className="faq-badge-icon" />
            <span>Got Questions?</span>
          </div>
          <h2 className="faq-header-title">
            Frequently Asked <span className="faq-title-accent">Questions</span>
          </h2>
          <p className="faq-header-sub">
            Everything you need to know about buying, selling and delivery on
            KisaanMart
          </p>
        </div>

        <div className="faq-category-tabs">
          <button
            className={`faq-cat-tab${activeTab === "customer" ? " faq-cat-tab--active" : ""}`}
            onClick={() => setActiveTab("customer")}
          >
            Customer
          </button>
          <button
            className={`faq-cat-tab${activeTab === "seller" ? " faq-cat-tab--active" : ""}`}
            onClick={() => setActiveTab("seller")}
          >
            Seller
          </button>
          <button
            className={`faq-cat-tab${activeTab === "delivery" ? " faq-cat-tab--active" : ""}`}
            onClick={() => setActiveTab("delivery")}
          >
            Delivery
          </button>
        </div>

        <Row className="align-items-center g-5">
          <Col lg={5} md={12} className="faq-visual-col">
            <div className="faq-images-stack">
              <div className="faq-img-main">
                <img src={seeds} alt="Premium seeds" />
                <div className="faq-img-badge">
                  <FaLeaf />
                  <span>Verified Sellers</span>
                </div>
              </div>
              <div className="faq-imgs-row">
                <div className="faq-img-small">
                  <img src={fruits} alt="Fresh fruits" />
                  <span className="faq-img-label">Crops</span>
                </div>
                <div className="faq-img-small">
                  <img src={fertilizer} alt="Fertilizers" />
                  <span className="faq-img-label">Store Products</span>
                </div>
              </div>
            </div>
          </Col>

          <Col lg={7} md={12}>
            {loading ? (
              <div className="faq-accordion">
                {[1, 2, 3, 4].map((i) => (
                  <div
                    key={i}
                    className="faq-item"
                    style={{ padding: "1rem 1.25rem" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <SkeletonBlock
                        width={i % 2 === 0 ? "60%" : "75%"}
                        height="16px"
                        borderRadius="4px"
                      />
                      <SkeletonBlock
                        width="18px"
                        height="18px"
                        borderRadius="4px"
                      />
                    </div>
                  </div>
                ))}
              </div>
            ) : faqData.length === 0 ? (
              <p className="faq-loading-text">No FAQs found.</p>
            ) : (
              <div className="faq-accordion">
                {faqData.map((item, idx) => {
                  const isOpen = openId === item.id;
                  return (
                    <div
                      key={item.id}
                      className={`faq-item${isOpen ? " faq-item--open" : ""}`}
                      style={{ animationDelay: `${idx * 0.07}s` }}
                    >
                      <button
                        className="faq-question"
                        onClick={() => toggle(item.id)}
                        aria-expanded={isOpen}
                      >
                        <span className="faq-question-text">
                          {item.question}
                        </span>
                        <span className="faq-toggle-icon">
                          {isOpen ? <FaMinus /> : <FaPlus />}
                        </span>
                      </button>
                      <div
                        className="faq-answer-wrapper"
                        style={{ maxHeight: isOpen ? "220px" : "0px" }}
                      >
                        <p className="faq-answer">{item.answer}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default FAQ;
